import { render, staticRenderFns } from "./ShopCardPresent.vue?vue&type=template&id=c97ca1e2&scoped=true"
import script from "./ShopCardPresent.vue?vue&type=script&lang=js"
export * from "./ShopCardPresent.vue?vue&type=script&lang=js"
import style0 from "./ShopCardPresent.vue?vue&type=style&index=0&id=c97ca1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97ca1e2",
  null
  
)

export default component.exports